<script setup lang="ts">
import { type PropType } from 'vue';
import { tabsProps } from 'naive-ui';

const props = defineProps({
  ...tabsProps,
  // The CM mocks use the pill segment switcher (Users/Roles, Upload/Select
  // existing); styling comes from the Tabs theme section.
  type: {
    type: String as PropType<'bar' | 'line' | 'card' | 'segment'>,
    default: 'segment',
  },
});
</script>

<template>
  <n-tabs v-bind="props">
    <slot />
  </n-tabs>
</template>
